import validateVar from "./validation/validateVariable";

export default function getContractSource(offer_consultant_id) {
    if (validateVar(offer_consultant_id) && offer_consultant_id > 0)
        return "enermakler";
    else return "Webseite";
}
